import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { ModalController, LoadingController } from '@ionic/angular';
import { GlobalService } from '../global.service';
import { ImageCropperPage } from '../image-cropper/image-cropper.page';
@Component({
  selector: 'app-personal',
  templateUrl: './personal.page.html',
  styleUrls: ['./personal.page.scss'],
})
export class PersonalPage implements OnInit {

    ismodal = false;
    character = GlobalService.CHARACTER;
    roles = GlobalService.Roles;
    src = "";
    filePicture = null;
    constructor(private router: Router, private globalService: GlobalService, private modalController: ModalController) { }

    close() {
        this.modalController.dismiss();
    }
    ngOnInit() {

        this.filePicture = document.getElementById("filePicture") as HTMLInputElement;

    }
    selectPicture() {
        this.filePicture.click();
    }
    validate(filename) {
        var valid = false;
        var _validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png"];
        if (filename.length > 0) {

            for (var j = 0; j < _validFileExtensions.length; j++) {
                var sCurExtension = _validFileExtensions[j];
                if (filename.substr(filename.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                    valid = true;
                    break;
                }
            }

            if (!valid) {
                this.globalService.toast("Sorry, " + filename + " is invalid, allowed extensions are: " + _validFileExtensions.join(", "));
                return false;
            }
        }
        return valid;
    }
    public fileChangeEvent(fileInput: any) {
        if (fileInput.target.files && fileInput.target.files[0]) {

            var that = this;
            var reader = new FileReader();
            if (this.validate(fileInput.target.files[0].name)) {
                reader.onload = function (e: any) {

                    that.cropImage(e.target.result);
                    //OPEN CROPPIE

                }
                reader.readAsDataURL(fileInput.target.files[0]);
            }
            this.filePicture.value = "";

        }
    }

    async cropImage(src) {

        const modal = await this.modalController.create({
            component: ImageCropperPage,
            componentProps: { src: src }
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data != null) {
            console.log(data);
            this.character.avatar = data;
            this.src = data;
        }


    }

    getDescription() {
        var item = this.roles.filter(e => { return e.name == this.character.role; });
        if (item.length > 0) {
            return item[0].description;
        }
        return "";
    }

}
